/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from 'react';
import './styles.css';
import { Button, Form, Row, Col, Spinner } from 'react-bootstrap';
import { Validator, ValidatorConfig } from 'json-data-validator';
import { RuleFactory } from 'json-data-validator/build/src/rules/RuleFactory';
import { GenericValidator } from 'json-data-validator/build/src/rules/GenericValidator';
import { RuleConfig } from 'json-data-validator/build/src/config/RuleConfig';
import emailProviders from 'email-providers/all.json';
import { parse } from 'tldts';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import {
    TextInput,
    ITextInputProps,
    NumberTextInput,
    INumberTextInputProps,
    EmailInput,
    IEmailInputProps,
    TextAreaInput,
    ITextAreaInputProps,
    PasswordInput,
    IPasswordInputProps,
    ChoosePhoto,
    IChoosePhotoProps,
    ImageDropZone,
    IImageDropZoneProps,
    FileDropZone,
    IFileDropZoneProps,
    DatePicker,
    IDatePickerProps,
    DateTimePicker,
    IDateTimePickerProps,
    IRadioButtonProps,
    RadioButton,
    BooleanButton,
    IBooleanButtonProps,
    INumberInputProps,
    NumberInput,
    HtmlEditor,
    IHtmlEditorProps,
    DynamicFields,
    IDynamicFieldsProps,
    ColorPicker,
    IColorPickerProps,
    SelectInput,
    ISelectInputProps,
    CountrySelectInput,
    ICountrySelectInputProps,
    PhoneNumberInput,
    Landline,
    IPhoneNumberInputProps,
    ILandlineInputProps,
    OTPInputComp,
    IOTPInputCompProps,
    SectionTitle,
    ISectionTitleProps,
    CheckBox,
    ICheckBoxProps,
    IMultipleLevelSelectionProps,
    MultipleLevelSelection,
    IMultiSelectInputProps,
    MultiSelectInput,
} from './components';
import toast from 'react-hot-toast';
import { TweetyForm } from './styles';
import moment from 'moment';

const SwalWithBootstrapButtons = withReactContent(
    Swal.mixin({
        customClass: {
            confirmButton: 'btn btn-primary me-3',
            cancelButton: 'btn btn-gray',
        },
        buttonsStyling: false,
    })
);

RuleFactory.register('MINLENGTH', (config: RuleConfig) => {
    return new GenericValidator(
        config,
        (value: string) => !value || value.length >= config.minlength!,
        `'%s' must have a length of minimum ${config.minlength}`
    );
});
export interface ITweetyWidgetCompProps {
    type:
        | 'text'
        | 'numbertext'
        | 'number'
        | 'email'
        | 'textarea'
        | 'password'
        | 'choosePhoto'
        | 'imageDropZone'
        | 'fileDropZone'
        | 'datepicker'
        | 'dateTimePicker'
        | 'radio'
        | 'bool'
        | 'htmlEditor'
        | 'dynamicFields'
        | 'colorPicker'
        | 'select'
        | 'countrySelect'
        | 'phoneNumber'
        | 'landlineNumber'
        | 'otp'
        | 'sectionTitle'
        | 'multiTypeSelection'
        | 'multiSelect'
        | 'checkBox';
    compProps:
        | ITextInputProps
        | INumberInputProps
        | INumberInputProps
        | IEmailInputProps
        | ITextAreaInputProps
        | IPasswordInputProps
        | IChoosePhotoProps
        | IImageDropZoneProps
        | IFileDropZoneProps
        | IDatePickerProps
        | IDateTimePickerProps
        | IRadioButtonProps
        | IBooleanButtonProps
        | IHtmlEditorProps
        | IDynamicFieldsProps
        | IColorPickerProps
        | ISelectInputProps
        | ICountrySelectInputProps
        | IPhoneNumberInputProps
        | ILandlineInputProps
        | IOTPInputCompProps
        | ISectionTitleProps
        | IMultipleLevelSelectionProps
        | IMultiSelectInputProps
        | ICheckBoxProps;
}

export interface ITweetyWidgetProps {
    fields: ITweetyWidgetCompProps[];
    initialData?: any;
    setInitData?(payload: any): void;
    className?: string;
    //setParish?: any;
    submitButtonLabel?: string;
    validatorConfig?: ValidatorConfig;
    labelColor?: string;
    layout?: any[];
    dynamicKey?: any;
    dynamicLayout?: any[];
    lookUpFields?: any;
    fontScale?: number;
    updateLookUpFields?(payload: any): void;
    onFormSubmit?(payload: any): void;
    onHandleError?(payload: any): void;
    onErrorFree?(): void;
    onChange?(id: any, payload: any): void;
    onUpdateDynamicLayData?(data: any): void;
    renderSubmitButton?(): any;
    onSelectChange?(id: string, payload: any): void;
    onDraftSave?(payload: any): void;
    renderSaveButton?: boolean;
    touchedStatus?: boolean;
    appealSubmit?: boolean;
    isNotCard?: boolean;
    _deletemanagerial?(id: any, payload: any): any;
    temp?: any;
    tempKey?: any;
    setStepHasError?(payload: any): any;
    stepHasError?: any;
    _setTouchedStatus?(payload: any): any;
    allTouched?: any;
    setPrevStepErr?(payload: any): any;
    _touchedStatus?: any;
    prevsteperr?: any;
    cityCall?(id: any, payload: any): any;
}

const checkLayout = (id: string, obj: any[]) => {
    console.log('target->', id, obj);
    for (const str of obj) {
        const splitter = str?.split(':');
        if (splitter && splitter[0]) {
            if (splitter[0] === id) {
                return true;
            }
        }
    }
    return false;
};

export const TweetyWidget = ({
    fields,
    initialData,
    submitButtonLabel,
    onFormSubmit,
    renderSubmitButton,
    onSelectChange,
    fontScale,
    setInitData,
    //setParish,
    _deletemanagerial,
    labelColor,
    layout,
    onUpdateDynamicLayData,
    dynamicKey,
    validatorConfig,
    dynamicLayout,
    onDraftSave,
    renderSaveButton,
    appealSubmit,
    onChange,
    onHandleError,
    onErrorFree,
    touchedStatus,
    lookUpFields,
    className,
    updateLookUpFields,
    temp,
    tempKey,
    isNotCard,
    setStepHasError,
    stepHasError,
    allTouched,
    _setTouchedStatus,
    _touchedStatus,
    setPrevStepErr,
    prevsteperr,
    cityCall,
}: ITweetyWidgetProps) => {
    console.log('jeyaramlayout-->', layout);
    console.log('jeyaramfields-->', fields);
    console.log('jramfy', dynamicKey);
    console.log('initialformData->', fields);
    console.log('34982758342795->insidetweetywidget', initialData);
    const [formData, updateFormData] = useState<any>(initialData);
    console.log('finalFormData->', formData);
    const [fieldLayout, updateFieldLayout] = useState<any>(layout ?? []);
    const [validated, setValidated] = useState(false);
    const [errors, setErrors] = useState<any>({});
    const [hasError, setHasError] = useState(false);
    const [touched, setTouched] = useState(touchedStatus ?? false);
    // const [touched2,setTouched2] = useState({});
    const [errorMsg, setErrorMsg] = useState<any>({});
    const [lookupFields, setLookupFields] = useState<any>(lookUpFields ?? {});
    const [spinner, setSpinner] = useState(false);
    // useEffect(()=>console.log("jeyaramuseEffectFieldLayout->",fieldLayout));
    useEffect(() => {
        setTouched(touchedStatus ?? false);
    }, [touchedStatus]);
    // useEffect(()=>{
    //     _setTouchedStatus && _setTouchedStatus({..._touchedStatus,[temp]:true});
    // },[temp])
    console.log('lkjh->', lookupFields, fieldLayout, formData, initialData);
    useEffect(() => {
        setLookupFields(lookUpFields ?? {});
    }, [lookUpFields]);
    useEffect(() => {});
    useEffect(() => {
        console.log('reachedh->');
        updateFieldLayout(layout ?? []);
    }, [layout]);

    const _resolveDynamicIssues = (
        id: string,
        payload: any,
        fullLayout: any,
        _allformData: any
    ) => {
        console.log('lk->', payload, dynamicLayout);
        let found = false;
        let _layout: any;
        let tempLayout: any = [];
        let _payload: string;
        if (
            typeof payload === 'string' &&
            dynamicLayout[id][payload?.trim()] !== undefined
        ) {
            found = true;
            _layout = dynamicLayout[id][payload?.trim()];
            _payload = payload?.trim();
            if (lookupFields?.[id] === undefined) {
                updateLookUpFields &&
                    updateLookUpFields({
                        ...lookupFields,
                        [id]: _layout,
                    });
                setLookupFields({
                    ...lookupFields,
                    [id]: _layout,
                });
            }
        } else if (Array.isArray(payload)) {
            for (const pld of payload) {
                if (typeof pld === 'string') {
                    if (dynamicLayout[id][pld?.trim()] !== undefined) {
                        found = true;
                        _layout = dynamicLayout[id][pld?.trim()];
                        _payload = pld?.trim();
                        if (lookupFields?.[id] === undefined) {
                            updateLookUpFields &&
                                updateLookUpFields({
                                    ...lookupFields,
                                    [id]: _layout,
                                });
                            setLookupFields({
                                ...lookupFields,
                                [id]: _layout,
                            });
                        }
                    }
                }
            }
        }
        let currLayout = fullLayout;
        let flag = false;
        console.log('lioo->', found, lookupFields, id);
        console.log('ans->', _allformData[id], payload);
        console.log('dubk->', dynamicLayout[id]);
        if (!found || _allformData[id]) {
            const blackListItems = [];
            Object.entries(dynamicLayout[id])?.forEach((ele) => {
                if (Array.isArray(ele[1])) {
                    ele[1].forEach((_ele) => {
                        blackListItems.push(_ele);
                        if (dynamicLayout[_ele]) {
                            Object.entries(dynamicLayout[_ele])?.forEach(
                                (item) => {
                                    if (Array.isArray(item[1])) {
                                        item[1].forEach((_item) => {
                                            blackListItems.push(_item);
                                        });
                                    }
                                }
                            );
                        }
                    });
                }
            });
            const originalLayout = removeDuplicateArrays([...fullLayout]);
            const updatedLayout = originalLayout?.filter((lo: any) => {
                let matched = false;
                for (const dlo of blackListItems) {
                    if (dlo === lo) {
                        matched = false;
                        break;
                    } else {
                        matched = true;
                    }
                }
                return matched;
            });

            currLayout = updatedLayout;
            console.log('dubk->', blackListItems, updatedLayout);
            tempLayout = updatedLayout;
            const _formData = {
                ..._allformData,
                [id]: payload,
            };
            for (const dlo of blackListItems) {
                for (const _str of dlo) {
                    const splitter = _str.split(':');
                    if (splitter && splitter[0]) {
                        if (_formData[splitter[0]] !== undefined) {
                            delete _formData[splitter[0]];
                        }
                    }
                }
            }
        }
        console.log('lioo->-', found, flag, _allformData[id], payload);
        if (found) {
            const index = currLayout?.findIndex(checkLayout.bind(null, id));
            console.log('lk->', index, id);
            let checkIfExistingIndex = -1;
            for (const lo of currLayout) {
                for (const obj of lo) {
                    const splitter = obj.split(':');
                    if (splitter && splitter[0]) {
                        if (splitter[0] === _payload) {
                            checkIfExistingIndex = 1;
                            break;
                        }
                    }
                }
            }
            console.log('lk->', index, checkIfExistingIndex, _layout);
            if (index !== -1 && checkIfExistingIndex === -1 && _layout) {
                const originalLayout = [...currLayout];
                originalLayout.splice(index + 1, 0, ..._layout);
                console.log('lioo->oriii', originalLayout);
                console.log('lk->', payload, dynamicLayout);
                tempLayout = originalLayout;
            }
        }
        return tempLayout;
    };
    console.log('liuya->', lookupFields, lookUpFields);

    useEffect(() => {
        let _allformData: any = { ...formData, ...initialData } ?? {};
        let fullLayout = fieldLayout ?? [];
        if (fieldLayout && _allformData && dynamicLayout) {
            Object.entries(dynamicLayout)?.forEach((entry) => {
                const id = entry?.[0],
                    payload = entry?.[1];
                if (payload && id && _allformData[id]) {
                    const tempLayout = _resolveDynamicIssues(
                        id,
                        _allformData[id],
                        fullLayout,
                        _allformData
                    );
                    if (tempLayout?.length > layout?.length) {
                        fullLayout = tempLayout;
                        console.log('liuy->', fullLayout);
                    }
                }
            });
            console.log('liuy->', fullLayout, _allformData);
            console.log('reachedh->');
            updateFieldLayout([...fullLayout]);
        }
        updateFormData({ ..._allformData });
    }, [initialData]);

    useEffect(() => {
        if (spinner) {
            setTimeout(() => {
                setSpinner(false);
            }, 5000);
        }
    }, [spinner]);
    const removeDuplicateArrays = (inputArray) => {
        const uniqueArray = inputArray.filter((array, index, arr) => {
            const stringifiedArray = JSON.stringify(array);
            return (
                index ===
                arr.findIndex(
                    (item) => JSON.stringify(item) === stringifiedArray
                )
            );
        });

        return uniqueArray;
    };
    const [numerrmsg, setnumerrmsg] = useState('Value not in range');
    //   console.log("removefunresult",removeDuplicateArrays([['hiii'],['hello'],['helo'],['hello']]));
    const _errmsg = (field: any) => {
        let min = field?.compProps?.min;
        let max = field?.compProps?.max;
        let data = formData[field?.compProps?.id];
        if (min && max) {
            return `value should be less than ${max} and more than ${min}`;
        } else if (min) {
            return `value should be more than ${min}`;
        } else if (max) {
            return `value should be less than ${max}`;
        } else {
            return `value not in range`;
        }
    };
    const checkforlimit = (field: any) => {
        let min = field?.compProps?.min;
        let max = field?.compProps?.max;
        let data = formData[field?.compProps?.id];
        if (min && max && data >= min && data <= max) {
            console.log('jramcase1', field?.compProps);
            // setnumerrmsg(
            //     `value should be between ${min} and ${max}`
            // );
            return true;
        } else if (!max && min && data >= min) {
            // setnumerrmsg(`value should be more than ${min}`);
            console.log('jramcase2', field?.compProps?.id);
            return true;
        } else if (!min && max && data <= max) {
            // setnumerrmsg(`value should be less than ${max}`);
            console.log('jramcase3', field?.compProps?.id);
            return true;
        } else if (max || min) {
            console.log('jramcase4', field?.compProps?.id);
            return false;
        }
        console.log('jramcase5', field?.compProps?.id);
        return true;
    };
    const checkForRequired = (data: any) => {
        console.log(data, typeof data, 'kj->');
        if (
            typeof data === 'undefined' ||
            typeof data === 'boolean' ||
            data === null ||
            data === undefined ||
            typeof data === 'null' ||
            (typeof data === 'string' && data === '') ||
            data === 'Select Options' ||
            data === 'none'
        ) {
            return true;
        }
        if (Array.isArray(data)) {
            if (data?.length === 0) {
                return true;
            }
            let newEle = 0;
            data?.forEach((item) => {
                if (!item?.operation) newEle = 1;
            });
            if (newEle === 0) {
                return true;
            }
        }
        return false;
    };
    // useEffect(()=>{

    // })

    useEffect(() => {
        if (touched || touchedStatus) {
            const errorsObj: any = {};
            let fullLayout = fieldLayout ?? [];
            let _allformData: any = formData ?? {};

            const errorMsgObj: any = {};
            const dynamicErrorsObj: any = {};
            const dynamicErrorMsgObj: any = {};
            Object.entries(initialData)?.forEach((entry) => {
                const id = entry?.[0],
                    payload = entry?.[1];
                _allformData = { ..._allformData, [id]: payload };
                if (payload && dynamicLayout) {
                    if (dynamicLayout[id]) {
                        const tempLayout = _resolveDynamicIssues(
                            id,
                            payload,
                            fullLayout,
                            _allformData
                        );
                        if (tempLayout?.length > 0) {
                            fullLayout = tempLayout;
                            console.log('liuy->', fullLayout);
                        }
                    }
                }
            });
            let _fields = [];
            let _hasError = false;
            console.log('liooo->-', fullLayout, _allformData);
            if (fullLayout && fullLayout?.length) {
                for (const row of fullLayout) {
                    for (const col of row) {
                        const found = fields.find(
                            (obj) =>
                                obj?.compProps?.id === col ||
                                obj?.compProps?.id === col?.split(':')[0]
                        );
                        if (found) {
                            _fields.push(found);
                        }
                    }
                }
            } else {
                console.log(` no layout`);
                _fields = fields;
            }
            for (const [index, field] of _fields?.entries()) {
                console.log(field, 'liooo->-');
                if (validatorConfig) {
                    const data = {
                        [field?.compProps?.id]: formData[field?.compProps?.id]
                            ?.val
                            ? formData[field?.compProps?.id]?.val
                            : formData[field?.compProps?.id],
                    };
                    const config =
                        validatorConfig?.ruleSets[0]?.fields[
                            field?.compProps?.id
                        ];

                    const _validatorConfig = {
                        ruleSets: [
                            {
                                fields: {},
                            },
                        ],
                    };
                    if (config) {
                        _validatorConfig.ruleSets[0].fields[
                            field?.compProps?.id
                        ] = config;
                    }
                    const validator = new Validator(_validatorConfig);
                    const res = validator.validate(data);
                    // console.log('res->', res, _validatorConfig);
                    if (res?.valid === false) {
                        errorsObj[field.compProps.id] = true;
                        _hasError = true;
                        errorMsgObj[field.compProps.id] = res?.message;
                    } else if (
                        field?.compProps?.required &&
                        checkForRequired(formData[field?.compProps?.id])
                    ) {
                        errorsObj[field.compProps.id] = true;
                        _hasError = true;
                        errorMsgObj[field.compProps.id] =
                            field?.compProps?.errorText ??
                            `${
                                field.compProps.label?.length >= 30 ||
                                !field.compProps.label
                                    ? 'This Field'
                                    : field.compProps.label
                            } is required`;
                    } else if (
                        field?.type === 'number' &&
                        (parseInt(formData[field?.compProps?.id]) < 0 ||
                            !checkforlimit(field))
                    ) {
                        errorsObj[field.compProps.id] = true;
                        _hasError = true;
                        errorMsgObj[field.compProps.id] =
                            field?.compProps?.errorText ?? _errmsg(field);
                    } else if (field?.type === 'dynamicFields') {
                        console.log(
                            'liooo->',
                            formData[field?.compProps?.lookUpField],
                            parseInt(formData[field?.compProps?.lookUpField]),
                            formData[field?.compProps?.id]?.length ?? 0
                        );
                        if (
                            formData[field?.compProps?.lookUpField] &&
                            parseInt(
                                formData[field?.compProps?.lookUpField]
                            ) !== (formData[field?.compProps?.id]?.length ?? 0)
                        ) {
                            // toast.error(field?.compProps?.errorText ?? '');
                            errorsObj[field.compProps.id] = true;
                            dynamicErrorsObj[field.compProps.id] = true;
                            _hasError = true;
                            errorMsgObj[field.compProps.id] =
                                field?.compProps?.errorText;
                            dynamicErrorMsgObj[field.compProps.id] =
                                field?.compProps?.errorText;
                        }
                        console.log(
                            'liooo->',
                            field.compProps.id,
                            errorsObj[field.compProps.id],
                            errorMsgObj[field.compProps.id]
                        );
                    }
                } else if (
                    field?.compProps?.required &&
                    checkForRequired(formData[field?.compProps?.id])
                ) {
                    errorsObj[field.compProps.id] = true;
                    _hasError = true;
                    errorMsgObj[field.compProps.id] =
                        field?.compProps?.errorText ??
                        `${
                            field.compProps.label?.length >= 30 ||
                            !field.compProps.label
                                ? 'This Field'
                                : field.compProps.label
                        } is required`;
                } else if (
                    field?.type === 'number' &&
                    (parseInt(formData[field?.compProps?.id]) < 0 ||
                        !checkforlimit(field))
                ) {
                    errorsObj[field.compProps.id] = true;
                    _hasError = true;
                    errorMsgObj[field.compProps.id] =
                        field?.compProps?.errorText ?? _errmsg(field);
                } else if (field?.type === 'dynamicFields') {
                    console.log(
                        'liooo->',
                        formData[field?.compProps?.lookUpField],
                        parseInt(formData[field?.compProps?.lookUpField]),
                        formData[field?.compProps?.id]?.length ?? 0
                    );
                    if (
                        formData[field?.compProps?.lookUpField] &&
                        parseInt(formData[field?.compProps?.lookUpField]) !==
                            (formData[field?.compProps?.id]?.length ?? 0)
                    ) {
                        // toast.error(field?.compProps?.errorText ?? '');
                        errorsObj[field.compProps.id] = true;
                        dynamicErrorsObj[field.compProps.id] = true;
                        _hasError = true;
                        errorMsgObj[field.compProps.id] =
                            field?.compProps?.errorText;
                        dynamicErrorMsgObj[field.compProps.id] =
                            field?.compProps?.errorText;
                    }
                    console.log(
                        'liooo->-',
                        field.compProps.id,
                        errorsObj[field.compProps.id],
                        errorMsgObj[field.compProps.id]
                    );
                }
            }
            // console.log('iob->', _hasError);
            console.log('kl->3', errorsObj, errorMsgObj, _allformData);
            if (_hasError) {
                setHasError(_hasError);
                setErrors({ ...errorsObj, ...dynamicErrorsObj });
                setErrorMsg({ ...errorMsgObj, ...dynamicErrorMsgObj });
                onHandleError && onHandleError(_hasError);
            } else {
                onErrorFree && onErrorFree();
            }
        }
    }, [touched, touchedStatus, allTouched]);
    useEffect(() => {
        console.log('firstformdata', prevsteperr);
    });
    useEffect(() => {
        if (tempKey) {
            const errorsObj: any = {};
            let fullLayout = fieldLayout ?? [];
            let _allformData: any = formData ?? {};

            const errorMsgObj: any = {};
            const dynamicErrorsObj: any = {};
            const dynamicErrorMsgObj: any = {};
            Object.entries(initialData)?.forEach((entry) => {
                const id = entry?.[0],
                    payload = entry?.[1];
                _allformData = { ..._allformData, [id]: payload };
                if (payload && dynamicLayout) {
                    if (dynamicLayout[id]) {
                        const tempLayout = _resolveDynamicIssues(
                            id,
                            payload,
                            fullLayout,
                            _allformData
                        );
                        if (tempLayout?.length > 0) {
                            fullLayout = tempLayout;
                            console.log('liuy->', fullLayout);
                        }
                    }
                }
            });
            let _fields = [];
            let _hasError = false;
            console.log('liooo->-', fullLayout, _allformData);
            if (fullLayout && fullLayout?.length) {
                for (const row of fullLayout) {
                    for (const col of row) {
                        const found = fields.find(
                            (obj) =>
                                obj?.compProps?.id === col ||
                                obj?.compProps?.id === col?.split(':')[0]
                        );
                        if (found) {
                            _fields.push(found);
                        }
                    }
                }
            } else {
                console.log(` no layout`);
                _fields = fields;
            }
            for (const [index, field] of _fields?.entries()) {
                console.log(field, 'liooo->-');
                if (validatorConfig) {
                    const data = {
                        [field?.compProps?.id]: formData[field?.compProps?.id]
                            ?.val
                            ? formData[field?.compProps?.id]?.val
                            : formData[field?.compProps?.id],
                    };
                    const config =
                        validatorConfig?.ruleSets[0]?.fields[
                            field?.compProps?.id
                        ];

                    const _validatorConfig = {
                        ruleSets: [
                            {
                                fields: {},
                            },
                        ],
                    };
                    if (config) {
                        _validatorConfig.ruleSets[0].fields[
                            field?.compProps?.id
                        ] = config;
                    }
                    const validator = new Validator(_validatorConfig);
                    const res = validator.validate(data);
                    // console.log('res->', res, _validatorConfig);
                    if (res?.valid === false) {
                        errorsObj[field.compProps.id] = true;
                        _hasError = true;
                        errorMsgObj[field.compProps.id] = res?.message;
                    } else if (
                        field?.compProps?.required &&
                        checkForRequired(formData[field?.compProps?.id])
                    ) {
                        errorsObj[field.compProps.id] = true;
                        _hasError = true;
                        errorMsgObj[field.compProps.id] =
                            field?.compProps?.errorText ??
                            `${
                                field.compProps.label?.length >= 30 ||
                                !field.compProps.label
                                    ? 'This Field'
                                    : field.compProps.label
                            } is required`;
                    } else if (
                        field?.type === 'number' &&
                        (parseInt(formData[field?.compProps?.id]) < 0 ||
                            !checkforlimit(field))
                    ) {
                        errorsObj[field.compProps.id] = true;
                        _hasError = true;
                        errorMsgObj[field.compProps.id] =
                            field?.compProps?.errorText ?? _errmsg(field);
                    } else if (field?.type === 'dynamicFields') {
                        console.log(
                            'liooo->',
                            formData[field?.compProps?.lookUpField],
                            parseInt(formData[field?.compProps?.lookUpField]),
                            formData[field?.compProps?.id]?.length ?? 0
                        );
                        if (
                            formData[field?.compProps?.lookUpField] &&
                            parseInt(
                                formData[field?.compProps?.lookUpField]
                            ) !== (formData[field?.compProps?.id]?.length ?? 0)
                        ) {
                            // toast.error(field?.compProps?.errorText ?? '');
                            errorsObj[field.compProps.id] = true;
                            dynamicErrorsObj[field.compProps.id] = true;
                            _hasError = true;
                            errorMsgObj[field.compProps.id] =
                                field?.compProps?.errorText;
                            dynamicErrorMsgObj[field.compProps.id] =
                                field?.compProps?.errorText;
                        }
                        console.log(
                            'liooo->',
                            field.compProps.id,
                            errorsObj[field.compProps.id],
                            errorMsgObj[field.compProps.id]
                        );
                    }
                } else if (
                    field?.compProps?.required &&
                    checkForRequired(formData[field?.compProps?.id])
                ) {
                    errorsObj[field.compProps.id] = true;
                    _hasError = true;
                    errorMsgObj[field.compProps.id] =
                        field?.compProps?.errorText ??
                        `${
                            field.compProps.label?.length >= 30 ||
                            !field.compProps.label
                                ? 'This Field'
                                : field.compProps.label
                        } is required`;
                } else if (
                    field?.type === 'number' &&
                    (parseInt(formData[field?.compProps?.id]) < 0 ||
                        !checkforlimit(field))
                ) {
                    errorsObj[field.compProps.id] = true;
                    _hasError = true;
                    errorMsgObj[field.compProps.id] =
                        field?.compProps?.errorText ?? _errmsg(field);
                } else if (field?.type === 'dynamicFields') {
                    console.log(
                        'liooo->',
                        formData[field?.compProps?.lookUpField],
                        parseInt(formData[field?.compProps?.lookUpField]),
                        formData[field?.compProps?.id]?.length ?? 0
                    );
                    if (
                        formData[field?.compProps?.lookUpField] &&
                        parseInt(formData[field?.compProps?.lookUpField]) !==
                            (formData[field?.compProps?.id]?.length ?? 0)
                    ) {
                        // toast.error(field?.compProps?.errorText ?? '');
                        errorsObj[field.compProps.id] = true;
                        dynamicErrorsObj[field.compProps.id] = true;
                        _hasError = true;
                        errorMsgObj[field.compProps.id] =
                            field?.compProps?.errorText;
                        dynamicErrorMsgObj[field.compProps.id] =
                            field?.compProps?.errorText;
                    }
                    console.log(
                        'liooo->-',
                        field.compProps.id,
                        errorsObj[field.compProps.id],
                        errorMsgObj[field.compProps.id]
                    );
                }
            }
            // console.log('iob->', _hasError);
            console.log('kl->3', errorsObj, errorMsgObj, _allformData);
            // if (_hasError) {
            //     setHasError(_hasError);
            //     setErrors({ ...errorsObj, ...dynamicErrorsObj });
            //     setErrorMsg({ ...errorMsgObj, ...dynamicErrorMsgObj });
            //     onHandleError && onHandleError(_hasError);
            // } else {
            //     onErrorFree && onErrorFree();
            // }
            if (Object.keys(errorsObj).length > 0) {
                setPrevStepErr({ [temp]: false });
            } else {
                setPrevStepErr({ [temp]: true });
            }
        }
    }, [initialData]);
    useEffect(() => {
        if (temp && _touchedStatus[temp]) {
            const errorsObj: any = {};
            let fullLayout = fieldLayout ?? [];
            let _allformData: any = formData ?? {};

            const errorMsgObj: any = {};
            const dynamicErrorsObj: any = {};
            const dynamicErrorMsgObj: any = {};
            Object.entries(initialData)?.forEach((entry) => {
                const id = entry?.[0],
                    payload = entry?.[1];
                _allformData = { ..._allformData, [id]: payload };
                if (payload && dynamicLayout) {
                    if (dynamicLayout[id]) {
                        const tempLayout = _resolveDynamicIssues(
                            id,
                            payload,
                            fullLayout,
                            _allformData
                        );
                        if (tempLayout?.length > 0) {
                            fullLayout = tempLayout;
                            console.log('liuy->', fullLayout);
                        }
                    }
                }
            });
            let _fields = [];
            let _hasError = false;
            console.log('liooo->-', fullLayout, _allformData);
            if (fullLayout && fullLayout?.length) {
                for (const row of fullLayout) {
                    for (const col of row) {
                        const found = fields.find(
                            (obj) =>
                                obj?.compProps?.id === col ||
                                obj?.compProps?.id === col?.split(':')[0]
                        );
                        if (found) {
                            _fields.push(found);
                        }
                    }
                }
            } else {
                console.log(` no layout`);
                _fields = fields;
            }
            for (const [index, field] of _fields?.entries()) {
                console.log(field, 'liooo->-');
                if (validatorConfig) {
                    const data = {
                        [field?.compProps?.id]: formData[field?.compProps?.id]
                            ?.val
                            ? formData[field?.compProps?.id]?.val
                            : formData[field?.compProps?.id],
                    };
                    const config =
                        validatorConfig?.ruleSets[0]?.fields[
                            field?.compProps?.id
                        ];

                    const _validatorConfig = {
                        ruleSets: [
                            {
                                fields: {},
                            },
                        ],
                    };
                    if (config) {
                        _validatorConfig.ruleSets[0].fields[
                            field?.compProps?.id
                        ] = config;
                    }
                    const validator = new Validator(_validatorConfig);
                    const res = validator.validate(data);
                    // console.log('res->', res, _validatorConfig);
                    if (res?.valid === false) {
                        errorsObj[field.compProps.id] = true;
                        _hasError = true;
                        errorMsgObj[field.compProps.id] = res?.message;
                    } else if (
                        field?.compProps?.required &&
                        checkForRequired(formData[field?.compProps?.id])
                    ) {
                        errorsObj[field.compProps.id] = true;
                        _hasError = true;
                        errorMsgObj[field.compProps.id] =
                            field?.compProps?.errorText ??
                            `${
                                field.compProps.label?.length >= 30 ||
                                !field.compProps.label
                                    ? 'This Field'
                                    : field.compProps.label
                            } is required`;
                    } else if (
                        field?.type === 'number' &&
                        (parseInt(formData[field?.compProps?.id]) < 0 ||
                            !checkforlimit(field))
                    ) {
                        errorsObj[field.compProps.id] = true;
                        _hasError = true;
                        errorMsgObj[field.compProps.id] =
                            field?.compProps?.errorText ?? _errmsg(field);
                    } else if (field?.type === 'dynamicFields') {
                        console.log(
                            'liooo->',
                            formData[field?.compProps?.lookUpField],
                            parseInt(formData[field?.compProps?.lookUpField]),
                            formData[field?.compProps?.id]?.length ?? 0
                        );
                        if (
                            formData[field?.compProps?.lookUpField] &&
                            parseInt(
                                formData[field?.compProps?.lookUpField]
                            ) !== (formData[field?.compProps?.id]?.length ?? 0)
                        ) {
                            // toast.error(field?.compProps?.errorText ?? '');
                            errorsObj[field.compProps.id] = true;
                            dynamicErrorsObj[field.compProps.id] = true;
                            _hasError = true;
                            errorMsgObj[field.compProps.id] =
                                field?.compProps?.errorText;
                            dynamicErrorMsgObj[field.compProps.id] =
                                field?.compProps?.errorText;
                        }
                        console.log(
                            'liooo->',
                            field.compProps.id,
                            errorsObj[field.compProps.id],
                            errorMsgObj[field.compProps.id]
                        );
                    }
                } else if (
                    field?.compProps?.required &&
                    checkForRequired(formData[field?.compProps?.id])
                ) {
                    errorsObj[field.compProps.id] = true;
                    _hasError = true;
                    errorMsgObj[field.compProps.id] =
                        field?.compProps?.errorText ??
                        `${
                            field.compProps.label?.length >= 30 ||
                            !field.compProps.label
                                ? 'This Field'
                                : field.compProps.label
                        } is required`;
                } else if (
                    field?.type === 'number' &&
                    (parseInt(formData[field?.compProps?.id]) < 0 ||
                        !checkforlimit(field))
                ) {
                    errorsObj[field.compProps.id] = true;
                    _hasError = true;
                    errorMsgObj[field.compProps.id] =
                        field?.compProps?.errorText ?? _errmsg(field);
                } else if (field?.type === 'dynamicFields') {
                    console.log(
                        'liooo->',
                        formData[field?.compProps?.lookUpField],
                        parseInt(formData[field?.compProps?.lookUpField]),
                        formData[field?.compProps?.id]?.length ?? 0
                    );
                    if (
                        formData[field?.compProps?.lookUpField] &&
                        parseInt(formData[field?.compProps?.lookUpField]) !==
                            (formData[field?.compProps?.id]?.length ?? 0)
                    ) {
                        // toast.error(field?.compProps?.errorText ?? '');
                        errorsObj[field.compProps.id] = true;
                        dynamicErrorsObj[field.compProps.id] = true;
                        _hasError = true;
                        errorMsgObj[field.compProps.id] =
                            field?.compProps?.errorText;
                        dynamicErrorMsgObj[field.compProps.id] =
                            field?.compProps?.errorText;
                    }
                    console.log(
                        'liooo->-',
                        field.compProps.id,
                        errorsObj[field.compProps.id],
                        errorMsgObj[field.compProps.id]
                    );
                }
            }
            // console.log('iob->', _hasError);
            console.log(
                'kl->3',
                errorsObj,
                errorMsgObj,
                _allformData,
                formData
            );
            if (_touchedStatus[temp]) {
                if (Object.keys(errorsObj).length > 0) {
                    setStepHasError &&
                        setStepHasError({ ...stepHasError, [temp]: false });
                } else {
                    setStepHasError &&
                        setStepHasError({ ...stepHasError, [temp]: true });
                }
            }
            if (_hasError) {
                setHasError(_hasError);
                setErrors({ ...errorsObj, ...dynamicErrorsObj });
                setErrorMsg({ ...errorMsgObj, ...dynamicErrorMsgObj });
                onHandleError && onHandleError(_hasError);
            } else {
                onErrorFree && onErrorFree();
            }
        }
    }, [tempKey]);
    const isPersonalEmail = (email: string): boolean => {
        const domain = parse(email).domain;
        return domain ? emailProviders.includes(domain) : false;
    };
    console.log('initial->', initialData, formData);
    const handleSubmit = (e?: any) => {
        console.log('pu->', formData);
        const form = e.currentTarget;
        const isValid = form.checkValidity();
        setStepHasError &&
            setStepHasError({ ...stepHasError, [temp]: isValid });
        e.preventDefault();
        e.stopPropagation();

        let hasError = false;
        const errorsObj: any = {};
        const errorMsgObj: any = {};
        const dynamicErrorsObj: any = {};
        const dynamicErrorMsgObj: any = {};
        let _fields = [];
        if (fieldLayout && fieldLayout?.length) {
            for (const row of fieldLayout) {
                for (const col of row) {
                    const found = fields.find(
                        (obj) =>
                            obj?.compProps?.id === col ||
                            obj?.compProps?.id === col?.split(':')[0]
                    );
                    if (found) {
                        _fields.push(found);
                    }
                }
            }
        } else {
            _fields = fields;
        }
        for (const [index, field] of _fields?.entries()) {
            // console.log('res->',formData[field?.compProps?.id],field?.type,parseInt(formData[field?.compProps?.id]) < 0);
            console.log('formdata->', formData);

            if (validatorConfig) {
                const data = {
                    [field?.compProps?.id]: formData[field?.compProps?.id]?.val
                        ? formData[field?.compProps?.id]?.val
                        : formData[field?.compProps?.id],
                };
                const config =
                    validatorConfig?.ruleSets[0]?.fields[field?.compProps?.id];

                const _validatorConfig = {
                    ruleSets: [
                        {
                            fields: {},
                        },
                    ],
                };
                if (config) {
                    _validatorConfig.ruleSets[0].fields[field?.compProps?.id] =
                        config;
                }
                const checkRequired = checkForRequired(
                    formData[field?.compProps?.id]
                );
                const validator = new Validator(_validatorConfig);
                const res = validator.validate(data);
                if (field.compProps.isExpiredCheck) {
                    try {
                        let _currData = moment();
                        let _value = formData[field?.compProps?.id];
                        _value = moment(_value);
                        let _dif = moment(_value).isAfter(_currData);
                        if (!_dif) {
                            errorsObj[field.compProps.id] = true;
                            hasError = true;
                            errorMsgObj[field.compProps.id] = field?.compProps
                                ?.expiryMessage
                                ? field?.compProps?.expiryMessage
                                : 'Expired!';
                        }
                    } catch (err: any) {
                        console.log(err);
                    }
                }
                if (field.type == 'checkBox') {
                    console.log(
                        'lui->',
                        checkRequired,
                        field.compProps.id,
                        formData[field?.compProps?.id]
                    );
                    console.log('tyyyppee', field);
                    if (
                        field.compProps.id === 'acknowledgementCheck' &&
                        formData[field?.compProps?.id].length < 3
                    ) {
                        errorsObj[field.compProps.id] = true;
                        hasError = true;
                    }
                }
                if (res?.valid === false) {
                    errorsObj[field.compProps.id] = true;
                    hasError = true;
                    errorMsgObj[field.compProps.id] = res?.message;
                } else if (field?.compProps?.required && checkRequired) {
                    console.log(
                        'ko->',
                        formData[field?.compProps?.id],
                        checkForRequired(formData[field?.compProps?.id]),
                        field.compProps.id
                    );
                    errorsObj[field.compProps.id] = true;
                    hasError = true;
                    errorMsgObj[field.compProps.id] =
                        field?.compProps?.errorText ??
                        `${
                            field.compProps.label?.length >= 30 ||
                            !field.compProps.label
                                ? 'This Field'
                                : field.compProps.label
                        } is required`;

                    console.log('ko->', errorsObj, errorMsgObj);
                } else if (
                    field?.type === 'number' &&
                    (parseInt(formData[field?.compProps?.id]) < 0 ||
                        !checkforlimit(field))
                ) {
                    errorsObj[field.compProps.id] = true;
                    hasError = true;
                    errorMsgObj[field.compProps.id] =
                        field?.compProps?.errorText ?? _errmsg(field);
                } else if (field?.type === 'dynamicFields') {
                    console.log(
                        'pl->',
                        formData[field?.compProps?.lookUpField],
                        parseInt(formData[field?.compProps?.lookUpField]),
                        formData[field?.compProps?.id]?.length ?? 0
                    );
                    if (
                        formData[field?.compProps?.lookUpField] &&
                        parseInt(formData[field?.compProps?.lookUpField]) !==
                            (formData[field?.compProps?.id]?.length ?? 0)
                    ) {
                        toast.error(field?.compProps?.errorText ?? '');
                        errorsObj[field.compProps.id] = true;
                        dynamicErrorsObj[field.compProps.id] = true;
                        hasError = true;
                        errorMsgObj[field.compProps.id] =
                            field?.compProps?.errorText;
                        dynamicErrorMsgObj[field.compProps.id] =
                            field?.compProps?.errorText;
                    }
                    console.log(
                        'pl->',
                        field.compProps.id,
                        errorsObj[field.compProps.id],
                        errorMsgObj[field.compProps.id]
                    );
                } else if (field?.addOnValidation) {
                    Array.isArray(field?.addOnValidation) &&
                        field?.addOnValidation?.forEach(
                            (addOnValidation: any) => {
                                console.log(
                                    'pk->',
                                    formData[field.compProps.id],
                                    addOnValidation?.currField,
                                    formData[addOnValidation]?.lookUpField,
                                    addOnValidation?.maxAllowed
                                );
                                if (
                                    formData[field.compProps.id] ===
                                        addOnValidation?.currField &&
                                    parseInt(
                                        formData[addOnValidation?.lookUpField]
                                    ) > addOnValidation?.maxAllowed
                                ) {
                                    console.log('pk->');
                                    errorsObj[field.compProps.id] = true;
                                    hasError = true;
                                    errorMsgObj[field.compProps.id] =
                                        field?.compProps?.errorText ?? '';
                                }
                            }
                        );
                } else if (
                    field?.compProps?.isPassport &&
                    formData[field.compProps.id]
                ) {
                    var today = moment().format('YYYY-MM-DD');
                    var currDate = formData[field.compProps.id];
                    var arr = currDate.split('-');
                    var todayArr = today.split('-');
                    let newExpiry = '';
                    if (parseInt(todayArr?.[1]) + 6 <= 12) {
                        newExpiry =
                            todayArr?.[0] +
                            '-' +
                            (parseInt(todayArr?.[1]) + 6 < 10
                                ? '0' + (parseInt(todayArr?.[1]) + 6).toString()
                                : (parseInt(todayArr?.[1]) + 6).toString()) +
                            '-' +
                            todayArr?.[2];
                    } //
                    else {
                        newExpiry =
                            (parseInt(todayArr?.[0]) + 1).toString() +
                            '-0' +
                            ((parseInt(todayArr?.[1]) + 6) % 12).toString() +
                            '-' +
                            todayArr?.[2];
                    }
                    console.log('expiry->', todayArr, currDate, newExpiry);
                    if (currDate < newExpiry) {
                        errorsObj[field.compProps.id] = true;
                        hasError = true;
                        errorMsgObj[field.compProps.id] =
                            field?.compProps?.errorText ??
                            'Expiry date should be atleast 6 months from today';
                    }
                } else if (
                    field?.compProps?.isMarriage &&
                    formData[field.compProps.id]
                ) {
                    var today = moment().format('YYYY-MM-DD');
                    var marriageDate = formData[field.compProps.id];
                    var todayArr = today.split('-');
                    let sixMonthsAgo = moment()
                        .subtract(6, 'months')
                        .format('YYYY-MM-DD');
                    console.log('six months ago->', sixMonthsAgo);
                    if (marriageDate >= sixMonthsAgo) {
                        errorsObj[field.compProps.id] = true;
                        hasError = true;
                        errorMsgObj[field.compProps.id] =
                            'The Marriage date must be a minimum of 6 months from the current date.';
                    }
                } else if (
                    field?.compProps?.isPersonalEmailValidation &&
                    formData[field.compProps.id]
                ) {
                    if (!isPersonalEmail(formData[field.compProps.id])) {
                        errorsObj[field.compProps.id] = true;
                        hasError = true;
                        errorMsgObj[field.compProps.id] =
                            'Invalid email: either missing or from a temporary provider';
                    }
                } else if (
                    field?.compProps?.isAdult &&
                    formData[field.compProps.id]
                ) {
                    var currDate = formData[field.compProps.id];
                    var arr = currDate.split('-');
                    var today = moment().format('YYYY-MM-DD');
                    var todayArr = today.split('-');
                    let err = false;

                    if (parseInt(todayArr?.[0]) - 18 > parseInt(arr?.[0])) {
                        err = true;
                    }
                    if (
                        parseInt(todayArr?.[0]) - 18 === parseInt(arr?.[0]) &&
                        parseInt(todayArr?.[1]) > parseInt(arr?.[1])
                    ) {
                        err = true;
                    }
                    if (
                        parseInt(todayArr?.[0]) - 18 === parseInt(arr?.[0]) &&
                        parseInt(todayArr?.[1]) === parseInt(arr?.[1]) &&
                        parseInt(todayArr?.[2]) >= parseInt(arr?.[2])
                    ) {
                        err = true;
                    }
                    console.log('errp->', err, arr, todayArr);
                    if (!err) {
                        errorsObj[field.compProps.id] = true;
                        hasError = true;
                        errorMsgObj[field.compProps.id] =
                            field?.compProps?.errorText ??
                            'Enter correct date as age must be atleast 18 years old';
                    }
                }
            } else if (
                field?.compProps?.required &&
                checkForRequired(formData[field?.compProps?.id])
            ) {
                console.log(
                    'ko->',
                    field?.compProps?.required,
                    checkForRequired(formData[field?.compProps?.id])
                );
                errorsObj[field.compProps.id] = true;
                hasError = true;
                errorMsgObj[field.compProps.id] =
                    field?.compProps?.errorText ??
                    `${
                        field.compProps.label?.length >= 30 ||
                        !field.compProps.label
                            ? 'This Field'
                            : field.compProps.label
                    } is required`;
            } else if (
                field?.type === 'number' &&
                (parseInt(formData[field?.compProps?.id]) < 0 ||
                    !checkforlimit(field))
            ) {
                errorsObj[field.compProps.id] = true;
                hasError = true;
                errorMsgObj[field.compProps.id] =
                    field?.compProps?.errorText ?? _errmsg(field);
            } else if (field?.type === 'dynamicFields') {
                console.log(
                    'pl->',
                    formData[field?.compProps?.lookUpField],
                    parseInt(formData[field?.compProps?.lookUpField]),
                    formData[field?.compProps?.id]?.length ?? 0
                );
                if (
                    formData[field?.compProps?.lookUpField] &&
                    parseInt(formData[field?.compProps?.lookUpField]) !==
                        (formData[field?.compProps?.id]?.length ?? 0)
                ) {
                    toast.error(field?.compProps?.errorText ?? '');
                    errorsObj[field.compProps.id] = true;
                    dynamicErrorsObj[field.compProps.id] = true;
                    hasError = true;
                    errorMsgObj[field.compProps.id] =
                        field?.compProps?.errorText;
                    dynamicErrorMsgObj[field.compProps.id] =
                        field?.compProps?.errorText;
                }
                console.log(
                    'pl->',
                    field.compProps.id,
                    errorsObj[field.compProps.id],
                    errorMsgObj[field.compProps.id]
                );
            } else if (field?.addOnValidation) {
                const addOnValidation = field?.addOnValidation;
                console.log(
                    'pk->',
                    formData[field.compProps.id],
                    addOnValidation?.currField,
                    formData[addOnValidation]?.lookUpField,
                    addOnValidation?.maxAllowed
                );
                if (
                    formData[field.compProps.id] ===
                        addOnValidation?.currField &&
                    parseInt(formData[addOnValidation?.lookUpField]) >
                        addOnValidation?.maxAllowed
                ) {
                    console.log('pk->');
                    errorsObj[field.compProps.id] = true;
                    hasError = true;
                    errorMsgObj[field.compProps.id] =
                        field?.compProps?.errorText ?? '';
                }
            } else if (
                field?.compProps?.isPassport &&
                formData[field.compProps.id]
            ) {
                var today = moment().format('YYYY-MM-DD');
                var currDate = formData[field.compProps.id];
                var todayArr = today.split('-');
                let newExpiry = '';
                if (parseInt(todayArr?.[1]) + 6 <= 12) {
                    newExpiry =
                        todayArr?.[0] +
                        '-' +
                        (parseInt(todayArr?.[1]) + 6 < 10
                            ? '0' + (parseInt(todayArr?.[1]) + 6).toString()
                            : (parseInt(todayArr?.[1]) + 6).toString()) +
                        '-' +
                        todayArr?.[2];
                } //
                else {
                    newExpiry =
                        (parseInt(todayArr?.[0]) + 1).toString() +
                        '-0' +
                        ((parseInt(todayArr?.[1]) + 6) % 12).toString() +
                        '-' +
                        todayArr?.[2];
                }
                console.log('expiry->', newExpiry);
                if (currDate < newExpiry) {
                    errorsObj[field.compProps.id] = true;
                    hasError = true;
                    errorMsgObj[field.compProps.id] =
                        field?.compProps?.errorText ??
                        'Expiry date should be atleast 6 months from today';
                }
            } else if (
                field?.compProps?.isMarriage &&
                formData[field.compProps.id]
            ) {
                var today = moment().format('YYYY-MM-DD');
                var marriageDate = formData[field.compProps.id];
                var todayArr = today.split('-');
                let sixMonthsAgo = moment()
                    .subtract(6, 'months')
                    .format('YYYY-MM-DD');
                console.log('six months ago->', sixMonthsAgo);
                if (marriageDate >= sixMonthsAgo) {
                    errorsObj[field.compProps.id] = true;
                    hasError = true;
                    errorMsgObj[field.compProps.id] =
                        'The Marriage date must be a minimum of 6 months from the current date.';
                }
            } else if (
                field?.compProps?.isAdult &&
                formData[field.compProps.id]
            ) {
                var currDate = formData[field.compProps.id];
                var arr = currDate.split('-');
                var today = moment().format('YYYY-MM-DD');
                var todayArr = today.split('-');
                let err = false;
                if (parseInt(todayArr?.[0]) - 18 > parseInt(arr?.[0])) {
                    err = true;
                }
                if (
                    parseInt(todayArr?.[0]) - 18 === parseInt(arr?.[0]) &&
                    parseInt(todayArr?.[1]) > parseInt(arr?.[1])
                ) {
                    err = true;
                }
                if (
                    parseInt(todayArr?.[0]) - 18 === parseInt(arr?.[0]) &&
                    parseInt(todayArr?.[1]) === parseInt(arr?.[1]) &&
                    parseInt(todayArr?.[2]) >= parseInt(arr?.[2])
                ) {
                    err = true;
                }
                console.log('errp->', err, arr, todayArr);

                if (!err) {
                    errorsObj[field.compProps.id] = true;
                    hasError = true;
                    errorMsgObj[field.compProps.id] =
                        field?.compProps?.errorText ??
                        'Enter correct date as age must be atleast 18 years old';
                }
            }
        }
        console.log(
            'pl->',
            errorsObj,
            errorMsgObj,
            dynamicErrorsObj,
            dynamicErrorMsgObj
        );
        // console.log('ko->',errorMsgObj);
        // setValidated(true);
        if (!hasError) {
            console.log('ki->1', errorsObj, errorMsgObj, formData);
            setErrors({});
            setErrorMsg({});
            onFormSubmit && onFormSubmit(formData);
        } else {
            window?.scrollTo(0, 0);
            setHasError(hasError);
            onHandleError && onHandleError(hasError);
            console.log(
                'ki->2',
                { ...errorsObj, ...dynamicErrorsObj },
                { ...errorMsgObj, ...dynamicErrorMsgObj },
                formData
            );
            setErrors({ ...errorsObj, ...dynamicErrorsObj });
            setErrorMsg({ ...errorMsgObj, ...dynamicErrorMsgObj });
            setStepHasError &&
                setStepHasError({ ...stepHasError, [temp]: false });
        }
    };
    console.log(errors, errorMsg, 'lp->');

    const deleteAllPrevDynamicItems = (id: string, payload: string) => {
        if (formData[id] && dynamicLayout[id]) {
            const allItemsToDelete = dynamicLayout?.[id];
            if (allItemsToDelete) {
                Object.entries(allItemsToDelete)
                    ?.filter((item) => item?.[0] !== payload)
                    ?.map((subItem) => {
                        subItem[1] &&
                            subItem[1]?.map((_subItem) => {
                                delete formData[_subItem];
                                delete errorMsg[_subItem];
                                delete errors[_subItem];
                            });
                    });
            }
        }
    };

    const handleCompChange = (id: string, payload: any) => {
        let hasError = false;
        const errorsObj: any = {};
        const errorMsgObj: any = {};
        let _lookUpField: any = lookupFields;
        if (id && payload && errors[id]) {
            delete errors[id];
            delete errorMsg[id];
        }

        onChange && onChange(id, payload);

        onSelectChange && onSelectChange(id, payload);
        updateFormData({
            ...formData,
            [id]: payload,
        });
        console.log('lk->', payload, dynamicLayout);
        if (payload && dynamicLayout) {
            if (dynamicLayout[id]) {
                console.log('lk->', payload, dynamicLayout);
                let found = false;
                let _layout: any;
                let tempLayout: any = [];
                let _payload: string;
                if (
                    typeof payload === 'string' &&
                    dynamicLayout[id][payload?.trim()] !== undefined
                ) {
                    found = true;
                    _layout = dynamicLayout[id][payload?.trim()];
                    _payload = payload?.trim();
                    if (lookupFields?.[id] === undefined) {
                        updateLookUpFields &&
                            updateLookUpFields({
                                ...lookupFields,
                                [id]: _layout,
                            });
                        setLookupFields({
                            ...lookupFields,
                            [id]: _layout,
                        });
                        _lookUpField[id] = _layout;
                    }
                } else if (Array.isArray(payload)) {
                    for (const pld of payload) {
                        if (typeof pld === 'string') {
                            if (dynamicLayout[id][pld?.trim()] !== undefined) {
                                found = true;
                                _layout = dynamicLayout[id][pld?.trim()];
                                _payload = pld?.trim();
                                if (lookupFields?.[id] === undefined) {
                                    updateLookUpFields &&
                                        updateLookUpFields({
                                            ...lookupFields,
                                            [id]: _layout,
                                        });
                                    setLookupFields({
                                        ...lookupFields,
                                        [id]: _layout,
                                    });
                                    _lookUpField[id] = _layout;
                                }
                            }
                        }
                    }
                }
                let currLayout = fieldLayout;
                console.log('mdf->', found, formData[id]);
                if (!found || formData[id]) {
                    const blackListItems = [];
                    Object.entries(dynamicLayout[id])?.forEach((ele) => {
                        if (Array.isArray(ele[1])) {
                            ele[1].forEach((_ele) => {
                                blackListItems.push(_ele);
                                if (dynamicLayout[_ele]) {
                                    Object.entries(
                                        dynamicLayout[_ele]
                                    )?.forEach((item) => {
                                        if (Array.isArray(item[1])) {
                                            item[1].forEach((_item) => {
                                                blackListItems.push(_item);
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    });
                    const originalLayout = removeDuplicateArrays([
                        ...fieldLayout,
                    ]);

                    console.log(
                        'mdf->',
                        fieldLayout,
                        originalLayout,
                        blackListItems
                    );

                    const updatedLayout = originalLayout?.filter((lo: any) => {
                        let matched = false;
                        for (const dlo of blackListItems) {
                            if (dlo === lo) {
                                matched = false;
                                break;
                            } else {
                                matched = true;
                            }
                        }
                        return matched;
                    });

                    currLayout = updatedLayout;
                    tempLayout = updatedLayout;
                    const _formData = { ...formData, [id]: payload };
                    console.log('mdf->', updatedLayout, _formData);
                    for (const dlo of blackListItems) {
                        for (const _str of dlo) {
                            const splitter = _str.split(':');
                            if (splitter && splitter[0]) {
                                console.log('poiu->', _formData[splitter[0]]);
                                if (_formData[splitter[0]] !== undefined) {
                                    if (
                                        Array.isArray(_formData[splitter[0]]) &&
                                        (_formData[splitter[0]]?.[0]?.base64 ||
                                            _formData[splitter[0]]?.[0]?.src)
                                    ) {
                                        let docData = _formData[
                                            splitter[0]
                                        ]?.map((item) => {
                                            return {
                                                ...item,
                                                operation: 'REMOVE',
                                            };
                                        });
                                        _formData[splitter[0]] = docData;
                                    } else {
                                        _formData[splitter[0]] = undefined;
                                    }
                                }
                            }
                        }
                    }
                    console.log('mdf->', _formData);
                    console.log('lioo->', {
                        ...formData,
                        ...(_formData || {}),
                    });
                    updateFormData({
                        ...formData,
                        ...(_formData || {}),
                    });
                    onUpdateDynamicLayData &&
                        onUpdateDynamicLayData({
                            ...formData,
                            ...(_formData || {}),
                        });
                }
                console.log('lioo->', found);
                if (found) {
                    const index = currLayout?.findIndex(
                        checkLayout.bind(null, id)
                    );
                    console.log('lk->', index, id);
                    let checkIfExistingIndex = -1;
                    for (const lo of currLayout) {
                        for (const obj of lo) {
                            const splitter = obj.split(':');
                            if (splitter && splitter[0]) {
                                if (splitter[0] === _payload) {
                                    checkIfExistingIndex = 1;
                                    break;
                                }
                            }
                        }
                    }
                    console.log(
                        'lk->',
                        payload,
                        dynamicLayout,
                        index,
                        checkIfExistingIndex,
                        _layout
                    );
                    if (
                        index !== -1 &&
                        checkIfExistingIndex === -1 &&
                        _layout
                    ) {
                        const originalLayout = [...currLayout];
                        originalLayout.splice(index + 1, 0, ..._layout);
                        console.log('lioo->oriii', originalLayout);
                        console.log('lk->', payload, dynamicLayout);
                        tempLayout = originalLayout;
                    }
                }
                console.log('lioo->', tempLayout);
                if (tempLayout?.length > 0) {
                    console.log('reachedh->');

                    updateFieldLayout([...tempLayout]);
                }
            }
        }
        console.log("Asir handle", id, payload, errorsObj, errorMsgObj);
    };
    console.log('mdf->', formData);
    const _renderFormGroup = (fldz: ITweetyWidgetCompProps[]) => {
        console.log('jeyaramformgruop');
        let _comp: any = [];
        // console.log(`_renderFormGroup #1`, fldz);
        for (const [index, field] of fldz.entries()) {
            // console.log(`_renderFormGroup #2`, field);
            if (field?.compProps) {
                field.compProps = {
                    ...field.compProps,
                    labelColor: labelColor,
                };
            } else {
                field.compProps = { labelColor: labelColor };
            }
            switch (field?.type) {
                case 'text':
                    _comp.push(
                        <TextInput
                            key={`tweety-text-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            fontScale={fontScale}
                            value={formData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case 'numbertext':
                    _comp.push(
                        <NumberTextInput
                            key={`tweety-numbertext-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            fontScale={fontScale}
                            value={formData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case 'number':
                    _comp.push(
                        <NumberInput
                            key={`tweety-number-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            fontScale={fontScale}
                            value={formData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case 'email':
                    _comp.push(
                        <EmailInput
                            key={`tweety-email-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            fontScale={fontScale}
                            value={formData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case 'textarea':
                    _comp.push(
                        <TextAreaInput
                            key={`tweety-textarea-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            fontScale={fontScale}
                            value={formData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case 'password':
                    _comp.push(
                        <PasswordInput
                            key={`tweety-password-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            fontScale={fontScale}
                            value={formData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case 'choosePhoto':
                    _comp.push(
                        <ChoosePhoto
                            key={`tweety-choose-photo-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            fontScale={fontScale}
                            value={formData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case 'imageDropZone':
                    _comp.push(
                        <ImageDropZone
                            key={`tweety-image-drop-zone-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            fontScale={fontScale}
                            value={formData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case 'fileDropZone':
                    _comp.push(
                        <FileDropZone
                            key={`tweety-file-drop-zone-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            fontScale={fontScale}
                            value={formData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case 'datepicker':
                    const addOnProps =
                        field?.compProps?.before &&
                        formData[field?.compProps?.before]
                            ? {
                                  beforeField:
                                      formData[field?.compProps?.before],
                              }
                            : field?.compProps?.after &&
                              formData[field?.compProps?.after]
                            ? { afterField: formData[field?.compProps?.after] }
                            : {};
                    _comp.push(
                        <DatePicker
                            key={`tweety-datepicker-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            {...addOnProps}
                            onCompChange={handleCompChange}
                            fontScale={fontScale}
                            value={formData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case 'dateTimePicker':
                    _comp.push(
                        <DateTimePicker
                            key={`tweety-date-time-picker-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            fontScale={fontScale}
                            value={formData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case 'radio':
                    _comp.push(
                        <RadioButton
                            key={`tweety-date-radio-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            fontScale={fontScale}
                            value={formData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case 'multiTypeSelection':
                    _comp.push(
                        <MultipleLevelSelection
                            key={`tweety-multi-type-select-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            fontScale={fontScale}
                            value={formData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case 'multiSelect':
                    _comp.push(
                        <MultiSelectInput
                            key={`tweety-multi-select-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            fontScale={fontScale}
                            value={formData[field?.compProps?.id]}
                            initialItems={
                                field?.compProps?.initialItems
                                    ? field?.compProps?.initialItems
                                    : formData[field?.compProps?.lookUpField]
                            }
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case 'bool':
                    _comp.push(
                        <BooleanButton
                            key={`tweety-boolean-radio-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            fontScale={fontScale}
                            value={formData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case 'htmlEditor':
                    _comp.push(
                        <HtmlEditor
                            key={`tweety-html-editor-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            fontScale={fontScale}
                            value={formData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case 'dynamicFields':
                    console.log('klo->', field?.compProps?.lookUpField);
                    _comp.push(
                        <DynamicFields
                            key={`tweety-dynamic-fields-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            fontScale={fontScale}
                            _deletemanagerial={_deletemanagerial}
                            cityCall={cityCall}
                            value={formData[field?.compProps?.id]}
                            totalSections={
                                formData[field?.compProps?.lookUpField]
                                    ? parseInt(
                                          formData[
                                              field?.compProps?.lookUpField
                                          ]
                                      )
                                    : field?.compProps?.lookUpField
                                    ? 0
                                    : undefined
                            }
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                            onDynamicFieldChange={onChange}
                        />
                    );
                    break;
                case 'colorPicker':
                    _comp.push(
                        <ColorPicker
                            key={`tweety-colorPicker-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            fontScale={fontScale}
                            value={formData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case 'select':
                    _comp.push(
                        <SelectInput
                            key={`tweety-select-input-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            fontScale={fontScale}
                            value={formData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case 'countrySelect':
                    console.log("Asir handle",field)
                    _comp.push(
                        <CountrySelectInput
                            key={`tweety-country-select-input-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            fontScale={fontScale}
                            value={ field.compProps?.id==='jamaicanNationality' ? 'Jamaica' : formData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case 'phoneNumber':
                    _comp.push(
                        <PhoneNumberInput
                            key={`tweety-phone-number-input-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            fontScale={fontScale}
                            value={formData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;

                case 'landlineNumber':
                    _comp.push(
                        <Landline
                            key={`tweety-text-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={(e) => {
                                if (!e || !e.target || typeof e.target.value !== "string") return;
                                let formattedValue = e.target.value.replace(/\D/g, "");
                                if (formattedValue.length > 3) {
                                    formattedValue = `(${formattedValue.slice(0, 3)}) ${formattedValue.slice(3, 8)}`.trim();
                                }
                                console.log("Asir landline",formattedValue);

                                handleCompChange(field?.compProps?.id, formattedValue);
                            }}
                            value={initialData[field?.compProps?.id] || ""}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                      
                case 'otp':
                    _comp.push(
                        <OTPInputComp
                            key={`tweety-otp-input-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            fontScale={fontScale}
                            value={formData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case 'sectionTitle':
                    _comp.push(
                        <SectionTitle
                            fontScale={fontScale}
                            key={`tweety-section-title-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                        />
                    );
                    break;
                case 'checkBox':
                    _comp.push(
                        <CheckBox
                            key={`tweety-check-box-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            fontScale={fontScale}
                            value={formData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                default:
                    console.log(`unsupported field type ${field?.type}`);
            }
        }
        return _comp;
    };

    const _renderSubmitButton = () => {
        if (renderSubmitButton) {
            return renderSubmitButton();
        }
        if (renderSaveButton) {
            return (
                <Row
                    className="mt-3"
                    style={{ justifyContent: 'space-around', display: 'flex' }}
                >
                    <Col xs={12} md={5} lg={4}>
                        <Button
                            variant="secondary"
                            type="button"
                            className="mt-2 animate-up-2 "
                            style={{
                                borderRadius: '10px',
                                height: '40px',
                                fontWeight: 'bold',
                                margin: 'auto',
                                background:
                                    'linear-gradient(to bottom right,#2f78d1,#104382)',
                            }}
                            onClick={() => {
                                setSpinner(true);
                                onDraftSave && onDraftSave(formData);
                            }}
                        >
                            {
                                // spinner ? (
                                //     <Spinner animation="border" size="sm" />
                                // ) :
                                'Save for later'
                            }
                        </Button>
                    </Col>
                    <Col xs={12} md={5} lg={4}>
                        <Button
                            variant="secondary"
                            type="submit"
                            className="mt-2 animate-up-2"
                            style={{
                                borderRadius: '10px',
                                height: '40px',
                                fontWeight: 'bold',

                                background:
                                    'linear-gradient(to bottom right,#2f78d1,#104382)',
                            }}
                        >
                            {'Next'}
                        </Button>
                    </Col>
                </Row>
            );
        } else {
            return (
                <Col className="m-auto">
                    <div className="mt-3">
                        <Button
                            variant="secondary"
                            type="submit"
                            className="mt-2 animate-up-2"
                            style={{
                                borderRadius: '10px',
                                height: '40px',
                                fontWeight: 'bold',
                                background:
                                    'linear-gradient(to bottom right,#2f78d1,#104382)',
                            }}
                        >
                            {submitButtonLabel}
                        </Button>
                    </div>
                </Col>
            );
            // return (
            //   // <div className="d-grid">
            //     <Row>
            //       <Col sm={12}>
            //     <Button variant="secondary" type="submit" style={{}}>
            //       {submitButtonLabel}
            //     </Button>
            //         </Col>
            //       </Row>
            //   // </div>
            // );
        }
    };

    const _renderFourColumns = (
        fieldz: ITweetyWidgetCompProps[],
        lo: string[]
    ) => {
        const _comp: any = [];
        const _sizer: any = {};
        for (const lay of lo) {
            const splitter = lay.split(':');
            if (splitter?.length === 2) {
                _sizer[splitter[0]] = Number(splitter[1]);
            }
        }
        for (const [index, field] of fieldz?.entries()) {
            _comp.push(
                <Col
                    key={`layout-4-columns-${index}`}
                    sm={
                        field.compProps.id in _sizer
                            ? _sizer[field.compProps.id]
                            : 3
                    }
                    className="mb-2"
                >
                    {_renderFormGroup([field])}
                </Col>
            );
        }
        return _comp;
    };

    const _renderThreeColumns = (
        fieldz: ITweetyWidgetCompProps[],
        lo: string[]
    ) => {
        const _comp: any = [];
        const _sizer: any = {};
        for (const lay of lo) {
            const splitter = lay.split(':');
            if (splitter?.length === 2) {
                _sizer[splitter[0]] = Number(splitter[1]);
            }
        }
        console.log(fieldz, fieldz?.entries(), lo, 'kj1->');
        for (const [index, field] of fieldz?.entries()) {
            _comp.push(
                <Col
                    key={`layout-3-columns-${index}`}
                    sm={
                        field.compProps.id in _sizer
                            ? _sizer[field.compProps.id]
                            : 4
                    }
                    className="mb-2"
                >
                    {_renderFormGroup([field])}
                </Col>
            );
        }
        return _comp;
    };

    const _renderTwoColumns = (
        fieldz: ITweetyWidgetCompProps[],
        lo: string[]
    ) => {
        const _comp: any = [];
        const _sizer: any = {};
        for (const lay of lo) {
            const splitter = lay.split(':');
            if (splitter?.length === 2) {
                _sizer[splitter[0]] = Number(splitter[1]);
            }
        }
        for (const [index, field] of fieldz?.entries()) {
            _comp.push(
                <Col
                    key={`layout-2-columns-${index}`}
                    sm={
                        field.compProps.id in _sizer
                            ? _sizer[field.compProps.id]
                            : 6
                    }
                    className="mb-2"
                >
                    {_renderFormGroup([field])}
                </Col>
            );
        }
        return _comp;
    };

    const _renderOneColumn = (
        fieldz: ITweetyWidgetCompProps[],
        lo: string[] = []
    ) => {
        const _comp: any = [];
        const _sizer: any = {};
        for (const lay of lo) {
            const splitter = lay.split(':');
            if (splitter?.length === 2) {
                _sizer[splitter[0]] = Number(splitter[1]);
            }
        }
        for (const [index, field] of fieldz?.entries()) {
            _comp.push(
                <Col
                    key={`layout-1-columns-${index}`}
                    sm={
                        field.compProps.id in _sizer
                            ? _sizer[field.compProps.id]
                            : 12
                    }
                    className="mb-2"
                >
                    {_renderFormGroup([field])}
                </Col>
            );
        }
        return _comp;
    };

    const _renderLayout = () => {
        console.log('jeyaraminsiderenderlayout->', fieldLayout);
        // updateFieldLayout(removeDuplicateArrays(fieldLayout));
        const _comp: any = [];
        if (fieldLayout && fieldLayout?.length > 0) {
            console.log('kj1->', fieldLayout);
            for (const [index, lo] of fieldLayout?.entries()) {
                if (lo.length === 4) {
                    const _lo = lo.map((obj) => obj.split(':')[0]);
                    const filtered = fields?.filter((field) =>
                        _lo.includes(field?.compProps?.id)
                    );
                    _comp.push(
                        <Row key={`layout-4-row-${index}`}>
                            {_renderFourColumns(filtered, lo)}
                        </Row>
                    );
                } else if (lo.length === 3) {
                    const _lo = lo.map((obj) => obj.split(':')[0]);
                    const filtered = fields?.filter((field) =>
                        _lo.includes(field?.compProps?.id)
                    );
                    console.log(filtered, lo, _lo, fields, 'kj1->');
                    _comp.push(
                        <Row key={`layout-3-row-${index}`}>
                            {_renderThreeColumns(filtered, lo)}
                        </Row>
                    );
                } else if (lo.length === 2) {
                    const _lo = lo.map((obj) => obj.split(':')[0]);
                    const filtered = fields?.filter((field) =>
                        _lo.includes(field?.compProps?.id)
                    );
                    _comp.push(
                        <Row key={`layout-2-row-${index}`}>
                            {_renderTwoColumns(filtered, lo)}
                        </Row>
                    );
                } else if (lo.length === 1) {
                    const _lo = lo.map((obj) => obj.split(':')[0]);
                    const filtered = fields?.filter((field) =>
                        _lo.includes(field?.compProps?.id)
                    );
                    _comp.push(
                        <Row key={`layout-1-row-${index}`}>
                            {_renderOneColumn(filtered, lo)}
                        </Row>
                    );
                } else {
                    console.log(`unsupported number of columns ${lo.length}`);
                }
            }
        } else {
            _comp.push(
                <Row key={`layout-1-row-default-layout`}>
                    {_renderOneColumn(fields)}
                </Row>
            );
        }
        return _comp;
    };

    return (
        <>
            <TweetyForm
                noValidate
                validated={validated}
                className={`tweety-form rounded ${className ?? ''}`}
                isNotCard={isNotCard}
                // className="mt-4"
                onSubmit={handleSubmit}
            >
                {layout ? _renderLayout() : _renderFormGroup(fields)}
                {_renderSubmitButton()}
            </TweetyForm>
        </>
    );
};

TweetyWidget.defaultProps = {
    initialData: {},
    submitButtonLabel: 'Submit',
    labelColor: '#000000',
};
